import { TextArea as SerendieTextArea } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import "./Styles.scss";
import React from "react";

export class TextArea extends BaseComponent<ITextAreaProps, ITextAreaState>
{
    public static requiredLabel?: string;

    public render(): JSX.Element
    {
        return <SerendieTextArea
            {...this.props}
            className={`${this.props.className ?? ''} serendie-textarea`}
            requiredLabel={this.props.requiredLabel ?? TextArea.requiredLabel}
        />
    }
}

export interface ITextAreaProps extends React.ComponentProps<typeof SerendieTextArea> { }

export interface ITextAreaState { }
